import React, { ErrorInfo as ReactErrorInfo } from "react";

/**
 * Props for ErrorPage component (from app's ErrorPage)
 */
export type ErrorPageProps = {
  error?: Error | unknown;
  status?: number;
};

/**
 * Props for ErrorPageAdapter component
 */
export type ErrorPageAdapterProps = {
  error: Error;
  errorInfo: ReactErrorInfo;
  ErrorPageComponent: React.ComponentType<ErrorPageProps>;
};

/**
 * Adapter component that converts React ErrorBoundary props (Error + ErrorInfo)
 * to ErrorPage props format (error + status)
 */
export function ErrorPageAdapter({
  error,
  errorInfo,
  ErrorPageComponent,
}: ErrorPageAdapterProps) {
  // Extract status from error if it has a status property
  const status =
    (error as any).status ?? (error as any).statusCode ?? undefined;

  return <ErrorPageComponent error={error} status={status} />;
}

